import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSortModule } from '@angular/material/sort';
import { TableComponent } from './table/table.component';
import { EventsCalendarComponent } from './events-calendar/events-calendar.component';
import { TopCedoleMemoriaTableComponent } from './tables/top-cedole-memoria-table/top-cedole-memoria-table.component';
import { Sotto100TableComponent } from './tables/sotto100-table/sotto100-table.component';
import { ScontiTableComponent } from './tables/sconti-table/sconti-table.component';
import { NextValutationDateTableComponent } from './tables/next-valutation-date-table/next-valutation-date-table.component';
import { BonusDiscretaTableComponent } from './tables/bonus-discreta-table/bonus-discreta-table.component';
import { TopFlopTableComponent } from './tables/top-flop-table/top-flop-table.component';
import { BenchmarkTableComponent } from './tables/benchmark-table/benchmark-table.component';
import { BonusContinuaTableComponent } from './tables/bonus-continua-table/bonus-continua-table.component';
import { LoaderComponent } from './loader/loader.component';
import { NewsTableComponent } from './news-slide/news-slide.component';
import { PaginationComponent } from './pagination/pagination.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { AddToWatchlistConfirmationDialogComponent } from './dialogs/add-to-watchlist-confirmation-dialog/add-to-watchlist-confirmation-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DeleteFromWatchlistConfirmationDialogComponent } from './dialogs/delete-from-watchlist-confirmation-dialog/delete-from-watchlist-confirmation-dialog.component';
import { AddToPortafoglioConfirmationDialogComponent } from './dialogs/add-to-portafoglio-confirmation-dialog/add-to-portafoglio-confirmation-dialog.component';
import { DeleteFromPortafoglioConfirmationDialogComponent } from './dialogs/delete-from-portafoglio-confirmation-dialog/delete-from-portafoglio-confirmation-dialog.component';
import { registerLocaleData } from '@angular/common';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { UploadImageComponent } from './upload-image/upload-image.component';

import localeFr from '@angular/common/locales/fr';
import { LineChartComponent } from './charts/line-chart/line-chart.component';
import { LineChartModule, NgxChartsModule } from '@swimlane/ngx-charts';
import { DeleteNotificationConfirmationDialogComponent } from './dialogs/delete-notification-confirmation-dialog/delete-notification-confirmation-dialog.component';
import { CarouselComponent } from './carousel/carousel.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselNewComponent } from './carousel-new/carousel-new.component';
import { AddNewProductModalComponent } from './dialogs/add-new-product-modal/add-new-product-modal.component';
import { DeleteProductConfirmationDialogComponent } from './dialogs/delete-product-confirmation-dialog/delete-product-confirmation-dialog.component';
import { DeleteCreditiConfirmationDialogComponentComponent } from './dialogs/delete-crediti-confirmation-dialog-component/delete-crediti-confirmation-dialog-component.component';
import { CarouselDashboardComponent } from './carousel-dashboard/carousel-dashboard.component';
import { CarouselDashboardPlaceholderComponent } from './carousel-dashboard/carousel-dashboard-placeholder/carousel-dashboard-placeholder.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CalendarViewWeekComponent } from './calendar-view-week/calendar-view-week.component';
import { CalendarWeekHeaderComponent } from './calendar-view-week/utils/calendar-week-header/calendar-week-header.component';
import { MatNativeDateModule } from '@angular/material/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { EventDetailsModalComponent } from './dialogs/event-details-modal/event-details-modal.component';
import { AddNewWatchlistDialogComponent } from './dialogs/add-new-watchlist-dialog/add-new-watchlist-dialog.component';
import { SaveAnalisiScenarioDialogComponent } from './dialogs/save-analisi-scenario-dialog/save-analisi-scenario-dialog.component';
import { AlertComponent } from './alert/alert.component';
import { UpdatePortfolioIsinDialogComponent } from './dialogs/update-portfolio-isin-dialog/update-portfolio-isin-dialog.component';
import { NuoviInQuotazioneComponent } from './tables/nuovi-in-quotazione/nuovi-in-quotazione.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';
import { PrivacyModalComponent } from '../features/privacy-modal/privacy-modal.component';
import { DeleteSubscriptionConfirmationDialogComponent } from './dialogs/delete-subscription-confirmation-dialog/delete-subscription-confirmation-dialog.component';
import { ConfirmUpdateSearchTableComponent } from './dialogs/confirm-update-search-table/confirm-update-search-table.component';
import { ConfirmUpdateVariazioneSottostanteAppoTableComponent } from './dialogs/confirm-update-variazione-sottostante-appo-table/confirm-update-variazione-sottostante-appo-table.component';
import { SafeHtmlPipe } from './custom-pipe/safe-html.pipe';
import { FormatCheckboxLabelPipe } from './custom-pipe/format-checkbox-label.pipe';
import { CheckDatePipe } from './custom-pipe/check-date.pipe';
import { VetrinaMeseComponent } from './tables/vetrina-mese/vetrina-mese.component';
import { MonthToStringPipe } from './custom-pipe/month-to-string.pipe';
import { RenameComponent } from './dialogs/rename-portfolio/rename.component';
import { DeleteCertificateConfirmationDialogComponent } from './dialogs/delete-certificate-confirmation-dialog/delete-certificate-confirmation-dialog.component';
import { DeletePortfolioConfirmationDialogComponent } from './dialogs/delete-portfolio-confirmation-dialog/delete-portfolio-confirmation-dialog.component';
import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FullPageSpinnerComponent } from './dialogs/full-page-spinner/full-page-spinner.component';
import { PopupNewsModalComponent } from './dialogs/popup-news-modal/popup-news-modal.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { TermsDialogComponent } from './dialogs/terms-dialog/terms-dialog.component';
import { ScrollToErrorDirective } from './directives/scroll-to-error.directive';
registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    // TABLES
    BenchmarkTableComponent,
    BonusContinuaTableComponent,
    BonusDiscretaTableComponent,
    NextValutationDateTableComponent,
    ScontiTableComponent,
    Sotto100TableComponent,
    NuoviInQuotazioneComponent,
    TopCedoleMemoriaTableComponent,
    TopFlopTableComponent,
    NewsTableComponent,

    TableComponent,
    // TABLE TOOLS
    PaginationComponent,
    // LOADERS
    LoaderComponent,
    // DIALOGS
    AddToWatchlistConfirmationDialogComponent,
    DeleteFromWatchlistConfirmationDialogComponent,
    AddToPortafoglioConfirmationDialogComponent,
    DeleteFromPortafoglioConfirmationDialogComponent,
    DeleteNotificationConfirmationDialogComponent,
    DeleteProductConfirmationDialogComponent,
    DeleteCreditiConfirmationDialogComponentComponent,
    // MODALS
    InfoModalComponent,
    PrivacyModalComponent,
    // OTHERS
    EventsCalendarComponent,
    ImageCropperComponent,
    UploadImageComponent,
    LineChartComponent,
    CarouselComponent,
    CarouselNewComponent,
    CarouselDashboardComponent,
    AddNewProductModalComponent,
    CarouselDashboardPlaceholderComponent,

    CalendarViewWeekComponent,
    CalendarWeekHeaderComponent,

    EventDetailsModalComponent,

    AddNewWatchlistDialogComponent,

    SaveAnalisiScenarioDialogComponent,

    AlertComponent,

    UpdatePortfolioIsinDialogComponent,

    DeleteSubscriptionConfirmationDialogComponent,

    ConfirmUpdateSearchTableComponent,

    ConfirmUpdateVariazioneSottostanteAppoTableComponent,

    SafeHtmlPipe,

    FormatCheckboxLabelPipe,

    CheckDatePipe,

    VetrinaMeseComponent,

    MonthToStringPipe,
    RenameComponent,
    DeleteCertificateConfirmationDialogComponent,
    DeletePortfolioConfirmationDialogComponent,
    AlertDialogComponent,
    FullPageSpinnerComponent,
    PopupNewsModalComponent,
    TermsDialogComponent,
    ScrollToErrorDirective
  ],
  exports: [
    // TABLES
    BenchmarkTableComponent,
    BonusContinuaTableComponent,
    BonusDiscretaTableComponent,
    NextValutationDateTableComponent,
    ScontiTableComponent,
    Sotto100TableComponent,
    NuoviInQuotazioneComponent,
    TopCedoleMemoriaTableComponent,
    TopFlopTableComponent,
    NewsTableComponent,

    TableComponent,
    // TABLE TOOLS
    PaginationComponent,
    // LOADERS
    LoaderComponent,
    // DIALOGS
    AddToWatchlistConfirmationDialogComponent,
    DeleteFromWatchlistConfirmationDialogComponent,
    AddToPortafoglioConfirmationDialogComponent,
    DeleteFromPortafoglioConfirmationDialogComponent,
    // MODALS
    InfoModalComponent,
    // OTHERS
    EventsCalendarComponent,
    ImageCropperComponent,
    UploadImageComponent,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    LineChartComponent,
    NgxChartsModule,
    CarouselComponent,
    CarouselNewComponent,
    CarouselDashboardComponent,

    CalendarViewWeekComponent,
    CalendarWeekHeaderComponent,

    EventDetailsModalComponent,
    AlertComponent,
    SafeHtmlPipe,
    FormatCheckboxLabelPipe,
    CheckDatePipe,
    VetrinaMeseComponent,
    MonthToStringPipe,
    ScrollToErrorDirective
  ],
    imports: [
        CommonModule,
        FormsModule,
        MatSortModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        MatTooltipModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatIconModule,
        RouterModule,
        LineChartModule,
        NgxChartsModule,
        NgbCarouselModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatNativeDateModule,
        MatSelectInfiniteScrollModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        MatProgressSpinnerModule,
        MatCheckboxModule
    ]
})
export class SharedModule {
}
